import { HOTJAR_SCRIPT } from "@/utils/analytics/hotjar";
import { HUBSPOT_EMBED_CODE, HUBSPOT_EMBED_ID } from "@/utils/analytics/hubspot";
import Script from "next/script";
import React, { useEffect } from "react";
import { initializeUnifyClient } from "@/utils/analytics/unify";
import { useRouter } from "next/router";
import { captureAndStoreUTMParameters } from "@/utils/analytics/utm";

export interface MarketingScriptsProps {
  // Note: the unity script actually being included is a loader script
  // The actual tracking script is loaded by it, so if the user comes
  // from a page where the unify script is present, they will still track
  // this page.
  noUnifyScript?: boolean;
}

export const MarketingScripts: React.FC<MarketingScriptsProps> = ({ noUnifyScript }) => {
  const router = useRouter();
  useEffect(() => {
    if (noUnifyScript) {
      return;
    }
    const unifyClient = initializeUnifyClient();
    unifyClient.mount();
    return () => {
      unifyClient.unmount();
    };
  }, [noUnifyScript]);

  const path = router.asPath;
  useEffect(() => {
    if (window._hsq == null) {
      window._hsq = [];
    }

    window._hsq.push(["setPath", path]);
    window._hsq.push(["trackPageView"]);
  }, [path]);

  // Capture and store UTM parameters on every route change
  useEffect(() => {
    captureAndStoreUTMParameters();
  }, [router.asPath]);

  return (
    <>
      <Script
        async
        defer
        key={"knock2"}
        id={"knock2"}
        src={"https://knock2-backend-2ba4792164c3.herokuapp.com/install/chalk_ai"}
      />
      <Script
        async
        defer
        id="luma-checkout"
        type={"text/javascript"}
        strategy={"afterInteractive"}
        src="https://embed.lu.ma/checkout-button.js"
      />
      <Script
        async
        defer
        key={HUBSPOT_EMBED_ID}
        id={HUBSPOT_EMBED_ID}
        type={"text/javascript"}
        strategy={"afterInteractive"}
        src={HUBSPOT_EMBED_CODE}
      />

      <Script
        async
        defer
        key={"hotjar"}
        type={"text/javascript"}
        strategy={"afterInteractive"}
        referrerPolicy="strict-origin-when-cross-origin"
        dangerouslySetInnerHTML={{ __html: HOTJAR_SCRIPT }}
      />
    </>
  );
};
